import { crud, http } from "../../../libs/react-mpk/services";

let service = new crud("/");

export const getLogScan = (query) => {
  return http.get(`/api/log_scan`, query);
};

export default service;